import { use } from 'react';

import KeyGroupKeysDataGrid from '../dataGrids/keyGroupKeysDataGrid';
import KeyGroupContext from '../providers/keyGroupContext';

const KeyGroupDetailsContainer = () => {
	const context = use(KeyGroupContext);
	return (
		<KeyGroupKeysDataGrid
			isLoading={context.isLoading}
			showTitle={false}
			overwrittenClientId={context.overwrittenClientId}
			keys={context.keyGroup?.keys ?? []}
		/>
	);
};

export default KeyGroupDetailsContainer;
